import { createSvgIcon } from '@mui/material';

export default createSvgIcon(
  <path d="M 5 3 C 3.9069372 3 3 3.9069372 3 5 L 3 19 C 3 20.093063 3.9069372 21 5 21 L 19 21 C 20.093063 21 21 20.093063 21 19 L 21 5 C 21 3.9069372 20.093063 3 19 3 L 5 3 z M 5 5 L 19 5 L 19 19 L 5 19 L 5 5 z M 7.4707031 8 L 11 13.300781 L 11 17 L 13 17 L 13 13.300781 L 16.529297 8 L 14.140625 8 L 12 11.199219 L 9.859375 8 L 7.4707031 8 z" />,
  'YCoordinateOutlined'
);
